// extracted by mini-css-extract-plugin
export default {"container":"style_container__W1Ubw","buttonsWrapper":"style_buttonsWrapper__TiSEd"};